/**
 * Designer-only page ownership helper.
 *
 * Home Assistant entities belong to individual state bindings and action
 * targets. This module intentionally contains no object-level entity model;
 * it only supports the transient template preview/page context.
 */

function parentOf(node) {
    return node?.parent ?? node?.getParent?.() ?? null;
}

/** Return the page/template_page that owns a Designer node. */
export function getOwningDesignerPage(object) {
    let node = object;
    const visited = new Set();
    while (node && !visited.has(node)) {
        visited.add(node);
        if (node.obj === 'page' || node.obj === 'template_page') return node;
        node = parentOf(node);
    }
    return null;
}
